<template>
  <nav class="navbar is-primary no-print" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <!-- Hamburger icon -->
      <a
        role="button"
        class="navbar-burger"
        :class="{ 'is-active': isMenuActive }"
        aria-label="menu"
        aria-expanded="false"
        @click="toggleMenu"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" :class="{ 'is-active': isMenuActive }">
      <div class="navbar-start">
        <!-- Add your left-side navigation items here -->
      </div>

      <div class="navbar-end">
        <!-- Dropdown for Competition -->
        <!-- Dropdown for Registration -->
        

        <div class="navbar-item">
          <router-link
            @click.native="menuClicked"
            class="navbar-item custom-link"
            to="/report/eventlist"
            :exact="true"
            active-class="is-active"
          >
            <span v-if="switchLang == 1">ວາລະງານຕ່າງໆ</span>
            <span v-else>ວາລະງານຕ່າງໆ</span>
          </router-link>

          <router-link
            @click.native="menuClicked"
            class="navbar-item custom-link"
            to="/report/businessmatching"
            :exact="true"
            active-class="is-active"
          >
            <span v-if="switchLang == 1">ການຈັບຄູ່ທຸລະກິດ</span>
            <span v-else>ການຈັບຄູ່ທຸລະກິດ</span>
          </router-link>

          <router-link
            @click.native="menuClicked"
            class="navbar-item custom-link"
            to="/report/competition"
            :exact="true"
            active-class="is-active"
          >
            <span v-if="switchLang == 1">ການແຂ່ງຂັນ</span>
            <span v-else>ການແຂ່ງຂັນ</span>
          </router-link>

          <router-link
            @click.native="menuClicked"
            class="navbar-item custom-link"
            to="/report/member"
            :exact="true"
            active-class="is-active"
          >
            <span v-if="switchLang == 1">ສະມາຊິກສະມາຄົມ</span>
            <span v-else>ສະມາຊິກສະມາຄົມ</span>
          </router-link>
        </div>


       

        <div class="navbar-item is-hoverable" style="margin-left: 10px;">
          <img class="image-area" :src="getLogoutImg()" @click="logout" />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "ReportMenu",
  data() {
    return {
      isMenuActive: false, // Toggles the main menu visibility (hamburger menu)
      activeDropdown: null, // Tracks the currently active dropdown menu
      switchLang: 1, // Language switch: 1 for Lao, 2 for English
      photopath: process.env.NODE_ENV === "production" 
                ? "https://lababiz.com/api/uploads/flag/"
                : "http://localhost/lababiz/api/uploads/flag/"
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive; // Toggle the hamburger menu
    },
    toggleDropdown(menu) {
      this.activeDropdown = this.activeDropdown === menu ? null : menu; // Toggle the dropdown
    },
    menuClicked() {
      this.activeDropdown = null; // Close the submenu when an item is clicked
    },
    logout() {
      this.$router.replace("/login");
    },
    getLogoutImg() {
      return this.photopath + "logout.png"; // Return the appropriate flag image
    }
  }
};
</script>

<style scoped>
.has-dropdown {
  margin-top: 6px;
  margin-left: 12px;
  margin-right: 12px;
}

.navbar-item {
  white-space: nowrap;
  transition: color 0.3s ease;
}

/* Default styles for large screens */
.navbar-item.custom-link {
  color: white; /* Default text color */
  background-color: #039be5;
}

/* Hover effect */
.navbar-item.custom-link:hover {
  /* background-color: #007bff; Background color when hovering */
  color: white; /* Color when hovering */
}

/* Active link state */
.navbar-item.custom-link.is-active {
  /* background-color: #007bff; Background color when the link is active */
  color: white; /* Color when the link is active */
}

.navbar-end {
  padding-right: 60px;
}

.navbar-burger span {
  background-color: white; /* Customize the hamburger menu color */
}

.navbar-link {
  cursor: pointer; /* Pointer cursor for clickable menu links */
}

.navbar-dropdown {
  animation: fadeIn 0.3s; /* Optional fade-in animation for submenu */
}

/* Media query for small screens (hamburger menu active state) */
@media screen and (max-width: 768px) {
  /* Change text color to blue when menu is active on small screens */
  .navbar-menu.is-active .navbar-item.custom-link {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  /* On hover, change text color to dark blue */
  .navbar-menu.is-active .navbar-item.custom-link:hover {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  .navbar-menu.is-active .navbar-item.custom-link.is-active {
    color: white; /* Change text color to blue for menu items on small screens */
    background-color: #039be5;
  }

  /* Ensure the menu background color is still white on small screens */
  .navbar-menu.is-active {
    background-color: white;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
